import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Label } from "~/components/ui/label";
import { TextArea } from "~/components/ui/textarea";

export function DiagnosisTextArea({
  defaultValue,
  onValueChange,
}: {
  defaultValue?: string | null;
  onValueChange(value: string): void;
}) {
  const intl = useIntl();

  return (
    <div className="form-group">
      <Label id="validation-condition" htmlFor="patient-diagnosis-value">
        <FormattedMessage id="HEADER_CONDITION" />
      </Label>

      <TextArea
        id="patient-diagnosis-value"
        data-matomo-mask
        name="diagnos"
        placeholder={intl.formatMessage({ id: "CONDITION_PLACEHOLDER" })}
        defaultValue={defaultValue ?? undefined}
        onChange={(e) => onValueChange(e.target.value)}
      />
    </div>
  );
}
